import React from 'react';
import cn from 'classnames';
import {
  getAvatarStyle,
  getInitialsFromName,
} from '../../../../LocationsPage/utils';

interface AvatarProps {
  avatarStyle?: number;
  className?: string;
  name: string;
}

const Avatar = ({ avatarStyle = 0, className = '', name }: AvatarProps) => {
  const initials = getInitialsFromName(name);

  return (
    <div
      className={cn(
        `flex justify-center items-center rounded-2xl w-8 h-8 ${
          getAvatarStyle(avatarStyle).backgroundColor
        } ${getAvatarStyle(avatarStyle).color}`,
        className,
      )}
    >
      <span className="text-base font-bold">{initials}</span>
    </div>
  );
};

export default Avatar;
